var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroup1171276166(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 493,
    height: 169,
    viewBox: "0 0 493 169",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M126.544 99.8638L83.9198 133.152L94.0432 95.7028L78.0591 88.9412L118.552 56.1734L81.7887 20.2848L72.731 51.4923L46.0908 80.0991H22.1145L20.5161 98.3034H13.0568C10.4994 100.384 4.17671 101.598 1.33506 101.944C-0.369915 102.36 -0.0857518 82.3529 0.269451 72.2972L5.0647 67.6161V60.8545L7.19592 58.774H24.7785L30.1065 53.0526V33.2879L32.2378 31.2074L49.8203 33.808L82.8542 0L130.807 50.452L143.594 42.6502L183.554 91.0217L199.539 89.4613L272 168L195.276 105.585L181.423 108.706L141.996 61.8947L126.544 99.8638Z",
    fill: "#E9E9E9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M347.544 108.164L304.92 137.885L315.043 104.449L299.059 98.4118L339.552 69.1548L302.789 37.1115L293.731 64.9752L267.091 90.517H243.115L241.516 106.771H234.057C231.499 108.628 225.177 109.712 222.335 110.022C220.63 110.393 220.914 92.5294 221.269 83.5511L226.065 79.3715V73.3344L228.196 71.4768H245.778L251.107 66.3684V48.7214L253.238 46.8638L270.82 49.1858L303.854 19L351.807 64.0464L364.594 57.0805L404.554 100.269L420.539 98.8762L493 169L416.276 113.272L402.423 116.059L362.996 74.2632L347.544 108.164Z",
    fill: "#E9E9E9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup1171276166);
export default __webpack_public_path__ + "static/media/Group 1171276166.686fd0d239d28239a7fd91c35e457479.svg";
export { ForwardRef as ReactComponent };